// Central configuration for the app
export const API_BASE_URL = 'https://dtsclientservicebackend.dockyardsoftware.com';